import { useMediaQuery, useTheme } from '@material-ui/core';
import { isServer } from 'src/utils/helpers/common';

export function useIsMobileOrTablet() {
    return isServer()
        ? false
        : Boolean(
              window?.navigator?.userAgent?.match(
                  /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
              )
          );
}
export function useIsMobile() {
    return isServer()
        ? undefined
        : Boolean(
              window?.navigator?.userAgent?.match(
                  /Android|BlackBerry|iPhone|Opera Mini|IEMobile|WPDesktop/i
              )
          );
}

export function useIsMobileSize() {
    const theme = useTheme(),
        isMobileSize = useMediaQuery(theme.breakpoints.only('xs'));

    return isMobileSize;
}
